import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { cardImageUrl, imageUrl } from '../services/helpers';
import { Marker, TrainerCutOut, TrainerIcon } from './styled';

/**
 * The game's own condition markers (server public/image/markers): a green swirl with a skull for poison, a red-orange
 * swirl with crossed band-aids for burn, flattened from a photo of the real tokens. Badly Poisoned is the same skull
 * on a purple swirl.
 */
const MARKERS = {
  poison: { label: 'Poisoned', image: '/markers/poison.png' },
  'bad-poison': { label: 'Badly Poisoned', image: '/markers/bad-poison.png' },
  burn: { label: 'Burned', image: '/markers/burn.png' },
};

/** A marker put on a Pokémon for a Special Condition, like the poison marker (conditionDisplay says which). */
export const ConditionMarker = ({ kind }) => {
  const marker = MARKERS[kind];
  return (
    <Marker title={marker.label} aria-label={marker.label} role="img">
      <img src={imageUrl(marker.image)} alt="" />
    </Marker>
  );
};

ConditionMarker.propTypes = {
  kind: PropTypes.oneOf(Object.keys(MARKERS)).isRequired,
};

/**
 * The item cut out of an attachable Trainer's artwork, by card name (public/image/attached on the server): the
 * capsule itself, background removed. Made from the Base Set cards; the same Trainers in later sets share the art.
 */
const CUT_OUTS = {
  PlusPower: '/attached/pluspower.png',
  Defender: '/attached/defender.png',
};

/**
 * A Trainer attached to a Pokémon, like PlusPower, as a little icon the size of the energy symbols beside it: its item
 * cut out of the card's artwork, or for a Trainer with no cut-out yet, a round crop of the artwork.
 */
export const AttachedTrainer = ({ card }) => {
  const name = card.get('name');
  const cutOut = CUT_OUTS[name];

  return cutOut
    ? <TrainerCutOut src={imageUrl(cutOut)} alt={name} title={name} />
    : <TrainerIcon style={{ backgroundImage: `url(${cardImageUrl(card)})` }} title={name} aria-label={name} role="img" />;
};

AttachedTrainer.propTypes = {
  card: PropTypes.instanceOf(Map).isRequired,
};
